import t from "../../../../i18n";
import { color } from "@ui";
import * as io from "io-ts";

export const DenormalizedEventStatus = io.keyof({
  TO_BE_ANALYSED: null,
  ONGOING: null,
  ACTION_IDENTIFIED: null,
  CLOSED: null,
});
export type DenormalizedEventStatus = io.TypeOf<typeof DenormalizedEventStatus>;
export const denormalizedFaultEventStatus = Object.keys(
  DenormalizedEventStatus.keys,
) as (keyof typeof DenormalizedEventStatus.keys)[];

export const sortedDenormalizedEventStatus = denormalizedFaultEventStatus
  .map(status => {
    switch (status) {
      case "TO_BE_ANALYSED":
        return { index: 0, status };
      case "ONGOING":
        return { index: 1, status };
      case "ACTION_IDENTIFIED":
        return { index: 2, status };
      case "CLOSED":
        return { index: 3, status };
      default:
        throw new Error(`Unknown status: ${status} fault event`);
    }
  })
  .sort((a, b) => a.index - b.index)
  .map(({ status }) => status);

export const FAULT_EVENTS_STATUS_COLORS: Record<NonNullable<DenormalizedEventStatus>, string> = {
  TO_BE_ANALYSED: color.oxygen400,
  ONGOING: color.darkNitrogen700,
  ACTION_IDENTIFIED: color.chlorine800,
  CLOSED: color.titanium600,
};

export const FAULT_EVENTS_STATUS_BACKGROUND_COLORS: Record<
  NonNullable<DenormalizedEventStatus>,
  string
> = {
  TO_BE_ANALYSED: color.oxygen50,
  ONGOING: color.lightNitrogen50,
  ACTION_IDENTIFIED: color.chlorine100,
  CLOSED: color.titanium100,
};

export const getEventStatusText = (status: DenormalizedEventStatus) => {
  switch (status) {
    case "TO_BE_ANALYSED":
      return t("project.fault_event.status.to_be_analyzed");
    case "ONGOING":
      return t("project.fault_event.status.on_going");
    case "ACTION_IDENTIFIED":
      return t("project.fault_event.status.action_identified");
    case "CLOSED":
      return t("project.fault_event.status.closed");
    default:
      throw new Error(status satisfies never);
  }
};

export function getEventStatusWeight(status: DenormalizedEventStatus) {
  switch (status) {
    case "TO_BE_ANALYSED":
      return 1;
    case "ONGOING":
      return 10;
    case "ACTION_IDENTIFIED":
      return 50;
    case "CLOSED":
      return 100;
    default:
      throw new Error(status satisfies never);
  }
}

export function getStatusOptions(status: DenormalizedEventStatus) {
  switch (status) {
    case "TO_BE_ANALYSED":
      return [
        {
          value: "TO_BE_ANALYSED",
          label: getEventStatusText("TO_BE_ANALYSED"),
        },
        {
          value: "ONGOING",
          label: getEventStatusText("ONGOING"),
        },
      ];
    case "ONGOING":
      return [
        {
          value: "ONGOING",
          label: getEventStatusText("ONGOING"),
        },
        {
          value: "ACTION_IDENTIFIED",
          label: getEventStatusText("ACTION_IDENTIFIED"),
        },
        {
          value: "CLOSED",
          label: getEventStatusText("CLOSED"),
        },
      ];
    case "ACTION_IDENTIFIED":
      return [
        {
          value: "ONGOING",
          label: getEventStatusText("ONGOING"),
        },
        {
          value: "ACTION_IDENTIFIED",
          label: getEventStatusText("ACTION_IDENTIFIED"),
        },
        {
          value: "CLOSED",
          label: getEventStatusText("CLOSED"),
        },
      ];
    case "CLOSED":
      return [
        {
          value: "ONGOING",
          label: getEventStatusText("ONGOING"),
        },
        {
          value: "ACTION_IDENTIFIED",
          label: getEventStatusText("ACTION_IDENTIFIED"),
        },
        {
          value: "CLOSED",
          label: getEventStatusText("CLOSED"),
        },
      ];
    default:
      throw new Error(status satisfies never);
  }
}
